export function removeEmptyFields<T extends object>(data: T): T {
  for (const key of Object.keys(data)) {
    if (data[key] === "" || data[key] == null) {
      delete data[key];
    }
  }
  return data;
}
